import { useGetCarriersIndexSetting } from '@/hooksApi';
import { useFetchListProvinces } from '@/hooksApi/useRegion';
import { CarrierCard } from './CarrierCard';
import { CarrierSettingsLoading } from './CarrierSettingsLoading';

interface CarrierSettingsProps {
  // Item 1 — Lock Shipping Rules. When true every carrier toggle is
  // disabled; the backend also 403s the toggle-active write.
  locked?: boolean;
}

export function CarrierSettings({ locked = false }: CarrierSettingsProps) {
  const { data: carriersIndexSetting, isLoading } = useGetCarriersIndexSetting();
  const { data: provincesData } = useFetchListProvinces();
  const provinceRows = provincesData?.object ?? [];
  const apiCarriers = (carriersIndexSetting?.object ?? []).filter((carrier) => carrier.is_active);

  if (isLoading) {
    return <CarrierSettingsLoading />;
  }

  return (
    <div className='grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 lg:grid-cols-3 sm:p-6'>
      {apiCarriers.map((item) => (
        <CarrierCard key={item.uid} item={item} disabled={locked} provinceRows={provinceRows} />
      ))}
    </div>
  );
}
